import { CommonEntity } from '../Utilities/CommonEntity';
import { PurchaseOrderHeaderEntity } from './PurchaseOrderHeaderEntity';
import { PurchaseOrderDetailEntity } from './PurchaseOrderDetailEntity';

export class PurchaseOrderOfflineDetailEntity extends CommonEntity {
  TransTypeId = 0;
  PurchaseOrderHead: PurchaseOrderHeaderEntity = new PurchaseOrderHeaderEntity();
  PurchaseOrderDetail: PurchaseOrderDetailEntity[];
  isEdit = false;
  SupplierName: string;
  transactionNumber = 0;
}
